import { get, post, put, destroy } from './base';


export const S3Serve = {
    getObjects: (params) =>
        get('/s3/objects', { params}),
    uploadUrl: (payload) =>
        post('/s3/upload-url', payload),
    createFolder: (payload) =>
        post('/s3/create-folder', payload),
    deleteObject: (payload) =>
        post('/s3/delete-object', payload)
}